import { WizardConfig, WizardErrors } from '../../types/wizard'

interface Props {
  config: WizardConfig
  updateConfig: (updates: Partial<WizardConfig>) => void
  errors: WizardErrors
}

const PRESET_COLORS = [
  { name: 'Blue', value: '#2563eb' },
  { name: 'Purple', value: '#7c3aed' },
  { name: 'Green', value: '#059669' },
  { name: 'Red', value: '#dc2626' },
  { name: 'Orange', value: '#ea580c' },
  { name: 'Pink', value: '#db2777' },
]

export default function Step4Branding({ config, updateConfig }: Props) {
  return (
    <div>
      <h2 className="text-3xl font-bold text-gray-900 mb-2">Customize Your Bot</h2>
      <p className="text-gray-600 mb-8">
        Make the chatbot match your brand. All fields are optional.
      </p>

      <div className="space-y-6">
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-3">
            Primary Color
          </label>
          <div className="flex gap-3 mb-3">
            {PRESET_COLORS.map(color => (
              <button
                key={color.value}
                onClick={() => updateConfig({ primaryColor: color.value })}
                className={`w-12 h-12 rounded-full border-4 transition-all ${
                  config.primaryColor === color.value
                    ? 'border-gray-900 scale-110'
                    : 'border-gray-200 hover:border-gray-300'
                }`}
                style={{ backgroundColor: color.value }}
                title={color.name}
              />
            ))}
          </div>
          <div className="flex items-center gap-3">
            <input
              type="color"
              value={config.primaryColor}
              onChange={(e) => updateConfig({ primaryColor: e.target.value })}
              className="w-16 h-10 rounded border border-gray-300 cursor-pointer"
            />
            <span className="text-sm text-gray-600">Or pick a custom color</span>
          </div>
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Bot Name Preference (Optional)
          </label>
          <input
            type="text"
            value={config.botNamePreference}
            onChange={(e) => updateConfig({ botNamePreference: e.target.value })}
            placeholder="e.g., Alex, Sam, Jordan"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
          />
          <p className="mt-1 text-sm text-gray-500">
            Leave blank for a random friendly name. Or suggest a name style you prefer.
          </p>
        </div>

        <div className="bg-primary-50 border border-primary-200 rounded-lg p-4">
          <h3 className="font-semibold text-primary-900 mb-2">Preview Your Bot</h3>
          <p className="text-sm text-primary-800 mb-3">
            After this step, you can preview your chatbot with your custom settings before checking out.
          </p>
        </div>
      </div>
    </div>
  )
}
